import React from 'react';
import {Link} from 'react-router-dom';
import footerData from 'data/footer.json';
import {footerSocialLinks} from 'config/employer.config';
import {
  Box,
  Stack,
  IconButton,
  Typography,
  Container,
  Link as EMAILTOLINK,
} from '@mui/material';

const {
  footer: {copyrightText, registeredLocationText},
} = footerData || {};

const AppFooter = ({menuItems = []}) => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        zIndex: 1201,
        position: 'relative',
        borderTop: '1px solid var(--mui-palette-divider)',
        backgroundColor: 'var(--mui-palette-background-paper)',
      }}>
      <Container>
        <Stack
          alignItems="center"
          justifyContent="center"
          gap={{xs: 1, sm: 3}}
          direction={{xs: 'column', sm: 'row'}}
          sx={{
            mb: '10px',
            fontSize: '12px',
            fontFamily: 'Fira Sans',
            a: {
              color: 'var(--mui-palette-grey-main)',
              '&:hover': {
                color: 'var(--mui-palette-grey-main)',
              },
            },
          }}>
          {menuItems?.map(({path, key, title, link}) => (
            <>
              {path ? (
                <Link to={path} key={key} style={{color: 'text.primary'}}>
                  {title}
                </Link>
              ) : (
                <EMAILTOLINK
                  key={key}
                  href={link}
                  target="_blank"
                  color="text.primary"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': {
                      color: 'text.primary',
                    },
                  }}>
                  {title}
                </EMAILTOLINK>
              )}
            </>
          ))}
        </Stack>
        <Stack
          gap={{xs: 2, sm: 3}}
          alignItems="center"
          justifyContent="center"
          direction={{xs: 'column', sm: 'row'}}>
          <Typography
            align="center"
            fontSize="12px"
            fontFamily="Fira Sans"
            color="var(--mui-palette-grey-main)">
            {copyrightText} | {registeredLocationText}
          </Typography>
          <Stack
            direction="row"
            gap={{xs: 1, sm: 2}}
            sx={{
              '& a:hover': {
                color: 'var(--mui-palette-action-active)',
              },
            }}>
            {footerSocialLinks.map((link, index) => (
              <IconButton key={index} href={link.link} target={link.target}>
                {link.icon}
              </IconButton>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default AppFooter;
